import { render, staticRenderFns } from "./GalleryBirthdayCake.vue?vue&type=template&id=5bf8c7d9&scoped=true&"
import script from "./GalleryBirthdayCake.vue?vue&type=script&lang=js&"
export * from "./GalleryBirthdayCake.vue?vue&type=script&lang=js&"
import style0 from "./GalleryBirthdayCake.vue?vue&type=style&index=0&id=5bf8c7d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf8c7d9",
  null
  
)

export default component.exports